import { render, staticRenderFns } from "./SGClusterSummary.vue?vue&type=template&id=cbf55c80&scoped=true"
import script from "./SGClusterSummary.vue?vue&type=script&lang=js"
export * from "./SGClusterSummary.vue?vue&type=script&lang=js"
import style0 from "./SGClusterSummary.vue?vue&type=style&index=0&id=cbf55c80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbf55c80",
  null
  
)

export default component.exports